export function normalizeOpenAgentPhoneDigits(value) {
  if (typeof value !== 'string') {
    return '';
  }
  let normalized = '';
  for (let index = 0; index < value.length; index = index + 1) {
    const char = value[index];
    if (char >= '0' && char <= '9') {
      normalized = normalized + char;
    }
  }
  return normalized;
}

export function normalizeOpenAgentTelValue(value) {
  if (typeof value !== 'string') {
    return '';
  }
  let normalized = '';
  for (let index = 0; index < value.length; index = index + 1) {
    const char = value[index];
    const isDigit = char >= '0' && char <= '9';
    if (isDigit === true || char === '+') {
      normalized = normalized + char;
    }
  }
  if (normalized.startsWith('++') === true) {
    return normalized.substring(1);
  }
  return normalized;
}

export function normalizeOpenAgentSelectedChannels(channelsValue, fallbackChannelsValue = []) {
  const current = Array.isArray(channelsValue) === true ? channelsValue.filter(channel => typeof channel === 'string' && channel.length > 0) : [];
  if (current.length > 0) {
    return Array.from(new Set(current));
  }
  const fallback = Array.isArray(fallbackChannelsValue) === true ? fallbackChannelsValue.filter(channel => typeof channel === 'string' && channel.length > 0) : [];
  if (fallback.length > 0) {
    return Array.from(new Set(fallback));
  }
  return [];
}

export function buildOpenAgentChannels(options = {}) {
  const translate = typeof options.t === 'function' ? options.t : ((key, fallback) => fallback);
  const selectedChannels = normalizeOpenAgentSelectedChannels(options.selectedChannels, options.fallbackChannels);
  const whatsappNumber = typeof options.whatsappNumber === 'string' ? options.whatsappNumber.trim() : '';
  const phoneNumber = typeof options.phoneNumber === 'string' ? options.phoneNumber.trim() : '';
  const channels = [];
  if (selectedChannels.includes('Web') === true) {
    channels.push({
      id: 'Web',
      label: 'web',
      description: translate('aiChatAgentSetup.openAgent.webDescription', 'Open the web agent'),
      icon: 'heroicons:globe-alt',
      actionLabel: translate('aiChatAgentSetup.buttons.openChat', 'Open Chat'),
      value: ''
    });
  }
  if (selectedChannels.includes('Web Voice Agent') === true) {
    channels.push({
      id: 'Web Voice Agent',
      label: translate('deploymentChannels.channels.webVoiceAgent.name', 'Web Voice Agent'),
      description: translate('aiChatAgentSetup.openAgent.webVoiceDescription', 'Open the web voice agent'),
      icon: 'tabler:microphone',
      actionLabel: translate('aiChatAgentSetup.buttons.openAgent', 'Open Agent'),
      value: ''
    });
  }
  if (selectedChannels.includes('Whatsapp') === true && whatsappNumber.length > 0) {
    channels.push({
      id: 'Whatsapp',
      label: translate('deploymentChannels.channels.whatsapp.name', 'Whatsapp'),
      description: translate('aiChatAgentSetup.openAgent.whatsappTitle', 'WhatsApp Number'),
      icon: 'tabler:brand-whatsapp',
      actionLabel: translate('aiChatAgentSetup.openAgent.openWhatsappWeb', 'Open WhatsApp Web'),
      value: whatsappNumber
    });
  }
  if (selectedChannels.includes('Whatsapp Voice') === true && whatsappNumber.length > 0) {
    channels.push({
      id: 'Whatsapp Voice',
      label: translate('deploymentChannels.channels.whatsappVoice.name', 'WhatsApp Voice'),
      description: translate('aiChatAgentSetup.openAgent.whatsappTitle', 'WhatsApp Number'),
      icon: 'tabler:brand-whatsapp',
      actionLabel: translate('aiChatAgentSetup.openAgent.openWhatsappWeb', 'Open WhatsApp Web'),
      value: whatsappNumber
    });
  }
  if (selectedChannels.includes('Phone') === true && phoneNumber.length > 0) {
    channels.push({
      id: 'Phone',
      label: translate('deploymentChannels.channels.phone.name', 'Phone'),
      description: translate('aiChatAgentSetup.openAgent.phoneTitle', 'Phone Number'),
      icon: 'tabler:phone',
      actionLabel: translate('aiChatAgentSetup.openAgent.callNow', 'Call'),
      value: phoneNumber
    });
  }
  return channels;
}

export function shouldOpenSingleAgentChannelDirectly(channelsValue) {
  if (Array.isArray(channelsValue) !== true || channelsValue.length !== 1) {
    return false;
  }
  const firstChannel = channelsValue[0];
  if (firstChannel === undefined || firstChannel === null) {
    return false;
  }
  return firstChannel.id !== 'Phone';
}

export function isWebOnlyOpenAgentChannel(channelsValue) {
  return Array.isArray(channelsValue) === true && channelsValue.length === 1 && channelsValue[0] !== undefined && channelsValue[0] !== null && channelsValue[0].id === 'Web';
}

export function isWebVoiceOnlyOpenAgentChannel(channelsValue) {
  return Array.isArray(channelsValue) === true && channelsValue.length === 1 && channelsValue[0] !== undefined && channelsValue[0] !== null && channelsValue[0].id === 'Web Voice Agent';
}

export function shouldShowDedicatedVoiceOpenButton(selectedChannels) {
  const channels = normalizeOpenAgentSelectedChannels(selectedChannels);
  if (channels.includes('Web Voice Agent') !== true) {
    return false;
  }
  if (channels.length === 1) {
    return false;
  }
  return true;
}

export function getOpenAgentButtonLabel(channelsValue, translate) {
  const resolvedTranslate = typeof translate === 'function' ? translate : ((key, fallback) => fallback);
  if (isWebOnlyOpenAgentChannel(channelsValue) === true) {
    return resolvedTranslate('aiChatAgentSetup.buttons.openChat', 'Open Chat');
  }
  if (isWebVoiceOnlyOpenAgentChannel(channelsValue) === true) {
    return resolvedTranslate('aiChatAgentSetup.buttons.openAgent', 'Open Agent');
  }
  return resolvedTranslate('aiChatAgentSetup.buttons.openAgent', 'Open Agent');
}
